<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="fines-page">
      <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'" class="align-center" :height="isMobile ? 140 : ''">
        <v-flex :class="isMobile ? '' : 'd-flex align-center'">
          <!-- <v-switch v-if="ygibdd_active" v-model="showAllFines" value :label="showAllFines ? $t('fines.cars_fines') : $t('fines.all_fines')
            " class="mt-0 pt-0" hide-details></v-switch> -->
          <v-spacer></v-spacer>
          <v-text-field v-model="search" data-testid="fines-search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
            hide-details></v-text-field>
          <v-flex :class="isMobile
            ? 'd-flex align-center justify-center mt-2'
            : 'd-flex align-center justify-center'
            ">
            <v-btn small color="success" to="/new_fine">{{
              $t("fines.new")
              }}</v-btn>
            <v-icon v-if="
              filtredFines &&
              filtredFines.length > 0
            " @click="toXlsx" class="ml-2" style="cursor: pointer" color="success">
              mdi-file-excel-outline
            </v-icon>
            <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
              }/${$root.$i18n.locale}/categories/4/guides/16`" target="_blank">
              <v-icon>mdi-help-circle</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-toolbar>
      <v-data-table :headers="fines_monitoring_active ? headers : headers_not_ygibdd" :items="filtredFines" :loading="isLoading"
        :loading-text="$t('custom.loading_table')" :search="search" :server-items-length.sync="total"
        :options.sync="tableOptions" :page.sync="page" item-key="id" mobile-breakpoint="100"
        :items-per-page="50" dense :footer-props="tableFooterProps([10, 30, 50, 150, 300, -1], `{0} ${$t('custom.of')} ${total}`)">
        <template slot="item" slot-scope="props">
          <tr :class="selectColor(props.item.pay_status_desc)">
            <td class="text-center">{{ props.item.number }}</td>
            <td class="text-center" v-if="props.item.car_code && props.item.car_id">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <router-link :to="{ name: 'CarCard', params: { id: props.item.car_id } }" v-bind="attrs" v-on="on">{{ props.item.car_code }}</router-link>
                </template>
                <span>{{ $t('cars.code') }}</span>
              </v-tooltip>
            </td>
            <td class="text-center" v-else>-</td>
            <td class="justify-center px-0" nowrap>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="green--text mr-1" v-bind="attrs" v-on="on" @click="paymentCompanyStart(props.item.number, props.item.id)">mdi-cash-multiple</v-icon>
                </template>
                <span>{{ $t('fines.pay_company') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="warning--text mr-1" v-bind="attrs" v-on="on" @click="paymentClientStart(props.item.number, props.item.id)">mdi-account-arrow-right-outline</v-icon>
                </template>
                <span>{{ $t('tooltips.pay_fine') }}</span>
              </v-tooltip>
              <v-icon class="mr-1" @click="editFine(props.item)">
                mdi-pencil-outline
              </v-icon>
              <v-tooltip bottom v-if="props.item.print_url || (props.item.uin && props.item.ygibdd_id)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mr-1" v-bind="attrs" v-on="on" @click="openFine(props.item)">mdi-open-in-new</v-icon>
                </template>
                <span>{{ props.item.print_url ? $t('fines.view_fine') : $t('fines.download') }}</span>
              </v-tooltip>
              <v-icon v-if="checkAdmin() && !props.item.uin" :data-testid="`delete-fine-${props.item.id}`" @click="deleteItem(props.item)">
                mdi-delete-forever
              </v-icon>
              <v-tooltip bottom v-if="props.item.client_id && props.item.booking_id">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="green--text mr-1" v-bind="attrs" v-on="on" @click="sendNotificationStart(props.item)">mdi-email-arrow-right</v-icon>
                </template>
                <span>{{ $t('fines.send_client') }}</span>
              </v-tooltip>
            </td>
            <td class="text-center" v-if="props.item.date">
              {{ returnDate(props.item.date) }}
            </td>
            <td class="text-center" v-else>
              {{ formatCreatedAtWithYear(props.item.violation_date) }}
            </td>
            <!-- Вынесен -->
            <!-- <td class="text-center">
                    {{ formatCreatedAtNoTime(props.item.decision_date) }}
                  </td> -->
            <td v-if="fines_monitoring_active && showSale(props.item.discount_date)" class="text-center" :style="checkLastDaySale(props.item.discount_date) ? 'color: red;' : ''
              ">
              {{ formatCreatedAtNoTime(props.item.discount_date) }}
              <v-tooltip bottom v-if="props.item.discount_expires_soon">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="warning" class="ml-1" v-bind="attrs" v-on="on">mdi-clock-alert-outline</v-icon>
                </template>
                <span>{{ $t('fines.discount_expires_soon') }}</span>
              </v-tooltip>
            </td>
            <td class="text-center" v-else-if="fines_monitoring_active && !showSale(props.item.discount_date)">
              -
            </td>
            <td v-if="fines_monitoring_active" class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="cursor: pointer;">{{ props.item.article || '-' }}</span>
                </template>
                <span>{{ props.item.article_description }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.offense_place">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ml-1" style="cursor: pointer; font-size: 14px;">📍</span>
                </template>
                <span>{{ props.item.offense_place }}</span>
              </v-tooltip>
            </td>
            <td class="text-center" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              <router-link :to="{ path: `/clients/${props.item.client_id}` }">{{
                props.item.client_name
                }}</router-link>
            </td>
            <td class="text-center">
              <v-tooltip bottom v-if="props.item.auto_select">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" small class="mx-1" v-bind="attrs" v-on="on">mdi-robot-outline</v-icon>
                </template>
                <span>{{ $t('tooltips.fine_auto_selected') }}</span>
              </v-tooltip>
              <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id
                }}</router-link>
            </td>
            <td v-if="fines_monitoring_active && company && company.multicurrency_cashboxes" class="text-center">
              {{ props.item.amount }}
            </td>
            <td v-if="fines_monitoring_active && !company.multicurrency_cashboxes" class="text-center">
              {{ props.item.amount }}{{ currency }}
            </td>
            <td v-if="fines_monitoring_active" class="text-center">
              <v-tooltip bottom v-if="props.item.is_revoked">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="text-center" color="warning" v-bind="attrs" v-on="on">mdi-plus</v-icon>
                </template>
                <span>{{ $t('tooltips.fine_declined') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="text-center" color="grey" v-bind="attrs" v-on="on">mdi-minus</v-icon>
                </template>
                <span>{{ $t('tooltips.fine_not_declined') }}</span>
              </v-tooltip>
            </td>
            <td v-if="company && company.multicurrency_cashboxes" class="text-center font-weight-bold">
              {{ props.item.sum }}
              <v-chip v-if="props.item.overdue" x-small color="error" dark class="ml-1">{{ $t('fines.overdue') }}</v-chip>
            </td>
            <td v-if="company && !company.multicurrency_cashboxes" class="text-center font-weight-bold">
              {{ props.item.sum }}{{ currency }}
              <v-chip v-if="props.item.overdue" x-small color="error" dark class="ml-1">{{ $t('fines.overdue') }}</v-chip>
            </td>
            <td class="text-center description-trunc">
              <read-more v-if="
                props.item.description && props.item.description.length > 0
              " :more-str="$t('custom.read')" :text="props.item.description" link="#" :less-str="$t('custom.less')"
                :max-chars="20"></read-more>
            </td>
            <td v-if="fines_monitoring_active" class="text-center">
              {{ props.item.pay_status_desc }}
            </td>
            <td class="text-center" v-if="props.item.paid">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="updateFinePaid(props.item.id, !props.item.paid)"
                    :loading="isLoadingUpdateFinePaid && props.item.id == editedFine.id"
                    style="color: green" v-bind="attrs" v-on="on">
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.fine_paid') }}</span>
              </v-tooltip>
            </td>
            <td class="text-center" v-if="!props.item.paid">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="updateFinePaid(props.item.id, !props.item.paid)"
                    :loading="isLoadingUpdateFinePaid && props.item.id == editedFine.id"
                    style="color: tomato" v-bind="attrs" v-on="on">
                    <v-icon>mdi-minus-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.fine_not_paid') }}</span>
              </v-tooltip>
            </td>
            <!-- Состояние -->
            <td class="text-center">
              <v-menu absolute offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :color="stateColor(props.item.state)" small block v-bind="attrs" v-on="on"
                    :loading="isLoadingUpdateState && props.item.id == editedFine.id">
                    {{
                      props.item.state ? translateState(props.item.state) : $t("fines.fresh")
                    }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link v-for="(state, index) in fines_state" :key="index"
                    @click="updateState(props.item.id, state.value)">
                    <v-list-item-title>
                      {{ state.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t("custom.no_data_in_table") }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
          {{ $t("tables.no_search_result", { msg: search }) }}
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-model="editDialog" :retain-focus="false" persistent fullscreen max-width="1200px"
      @keydown.esc="editDialog = false">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("custom.editing") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="editDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field v-model.number="editedFine.sum" :disabled="fines_monitoring_active"
                :label="$t('custom.amount')"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field v-model="editedFine.number" :disabled="fines_monitoring_active"
                :label="$t('fines.number')"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete v-model="selected_booking" :loading="isLoadingBookings"
                :search-input.sync="search_booking" flat clearable :label="$t('bookings.number_booking')"
                :items="bookings" return-object item-text="id_string" item-value="id"
                :hint="selected_booking && selected_booking.car ? selected_booking.car.code : ''">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <vc-date-picker v-if="!fines_monitoring_active" v-model="fine_date" mode="dateTime" :model-config="calendarConfig"
                :attributes="calendar_attributes" is24hr :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                <template v-slot="{ inputEvents }">
                  <v-text-field :value="fine_date_formatted" :disabled="fines_monitoring_active" v-on="inputEvents"
                    :label="$t('custom.date')" readonly hide-details />
                </template>
              </vc-date-picker>
              <vc-date-picker v-else-if="fines_monitoring_active && editedFine.violation_date == null" v-model="fine_date"
                mode="dateTime" :model-config="calendarConfig" :attributes="calendar_attributes" is24hr :utc="true"
                :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                <template v-slot="{ inputEvents }">
                  <v-text-field :value="fine_date_formatted" v-on="inputEvents" :label="$t('custom.date')" readonly
                    hide-details />
                </template>
              </vc-date-picker>
              <v-text-field v-else v-model="fine_date_formatted" :disabled="fines_monitoring_active" :label="$t('custom.date')"
                readonly hide-details />
            </v-col>
            <v-col cols="12" xs="12" sm="2" md="5">
              <v-select v-model="editedFine.state" clearable :items="fines_state" item-text="text" item-value="value"
                :label="$t('bookings.select_state')"></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="5" v-if="showClientSearch">
              <v-autocomplete v-model="client" item-text="fullname" item-value="id" :loading="isLoadingClients"
                :search-input.sync="search_client" flat hide-no-data hide-details clearable
                :label="$t('bookings.select_client')" :items="clients" return-object>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="5" v-if="!showClientSearch && client" @click="showClientSearch = true">
              <v-text-field readonly :value="client.fullname" :label="$t('custom.client')"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="5" v-if="!showClientSearch && !client" @click="showClientSearch = true">
              <v-text-field readonly :label="$t('custom.client')"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12">
              <v-textarea v-model="editedFine.description" rows="1" :label="$t('fines.description')"
                :placeholder="$t('fines.description_2')"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="
            (editDialog = false), (client = null), (showClientSearch = false)
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="saveFine()">
            {{ $t("custom.save") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentClientDialog" :retain-focus="false" persistent max-width="600px">
      <v-card :loading="isLoadingSaveClientPayment">
        <v-card-title>
          <span class="headline">{{ $t("fines.pay_client") }}</span>
          <v-icon class="ml-2 green--text" @click="saveClientPayment()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="paymentClientDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-row align="center" class="mt-2">
                <v-col auto>
                  <v-text-field v-model.number="paymentClientData.sum" :label="$t('bookings.get_payment')" dense
                    :messages="messageInBaseCurrency(paymentClientData.sum, paymentClientData.currency_id)"></v-text-field>
                </v-col>
                <v-col auto v-if="company && company.multicurrency_cashboxes">
                  <v-select v-model="paymentClientData.company_cashbox" :items="active_company_cashboxes"
                    :item-text="item => item.name" :return-object="true"
                    @change="paymentClientData.currency_id = paymentClientData.company_cashbox.currency_id, paymentClientData.company_cashbox_id = paymentClientData.company_cashbox.id"
                    :label="$t('companies.currency')" dense></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-col cols="12" class="d-flex align-center justify-space-between">
                  <v-checkbox v-if="company && company.cash_payment" v-model="paymentClientData.type" color="success"
                    value="Наличные" :disabled="paymentClientData.type == 'Терминал' ||
                      paymentClientData.type == 'На карту' ||
                      paymentClientData.type == 'Р/с' ||
                      paymentClientData.type == 'Баланс клиента' ||
                      isLoading
                      " class="mt-0 mr-0" dense hide-details :style="paymentClientData.type == 'Терминал' ||
                        paymentClientData.type == 'На карту' ||
                        paymentClientData.type == 'Р/с' ||
                        paymentClientData.type == 'Баланс клиента'
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="success" v-tooltip="{
                        content: $t('tooltips.cash_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-cash
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.cashless_payment" v-model="paymentClientData.type"
                    color="warning" value="Терминал" :disabled="paymentClientData.type == 'Наличные' ||
                      paymentClientData.type == 'На карту' ||
                      paymentClientData.type == 'Р/с' ||
                      paymentClientData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentClientData.type == 'Наличные' ||
                        paymentClientData.type == 'На карту' ||
                        paymentClientData.type == 'Р/с' ||
                        paymentClientData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-contactless-payment-circle-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.card_to_card_payment" v-model="paymentClientData.type"
                    color="info" value="На карту" :disabled="paymentClientData.type == 'Наличные' ||
                      paymentClientData.type == 'Терминал' ||
                      paymentClientData.type == 'Р/с' ||
                      paymentClientData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentClientData.type == 'Наличные' ||
                        paymentClientData.type == 'Терминал' ||
                        paymentClientData.type == 'Р/с' ||
                        paymentClientData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="info" v-tooltip="{
                        content: $t('money.card_to_card'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-credit-card-check-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.entity_payment" v-model="paymentClientData.type"
                    color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="paymentClientData.type == 'Наличные' ||
                      paymentClientData.type == 'Терминал' ||
                      paymentClientData.type == 'На карту' ||
                      paymentClientData.type == 'Баланс клиента'
                      " :style="paymentClientData.type == 'Наличные' ||
                        paymentClientData.type == 'Терминал' ||
                        paymentClientData.type == 'На карту' ||
                        paymentClientData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        " v-tooltip="{
                          content: $t('tooltips.entity_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                    <template v-slot:label>
                      <v-icon class="text-center" color="secondary">
                        mdi-bank
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.client_payment" v-model="paymentClientData.type" color="error"
                    class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="paymentClientData.type == 'Наличные' ||
                      paymentClientData.type == 'Терминал' ||
                      paymentClientData.type == 'На карту' ||
                      paymentClientData.type == 'Р/с'
                      " :style="paymentClientData.type == 'Наличные' ||
                        paymentClientData.type == 'Терминал' ||
                        paymentClientData.type == 'На карту' ||
                        paymentClientData.type == 'Р/с' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        " v-tooltip="{
                          content: $t('money.client_balance'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                    <template v-slot:label>
                      <v-icon class="text-center" color="error">
                        mdi-account-arrow-right
                      </v-icon>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12">
              <v-select v-model="paymentClientData.state" :items="fines_state" item-text="text" item-value="value"
                :label="$t('bookings.select_state')"></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(paymentClientDialog = false)">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="saveClientPayment()" :loading="isLoadingSaveClientPayment">
            {{ $t("custom.save") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentCompanyDialog" :retain-focus="false" persistent max-width="600px">
      <v-card :loading="isLoadingSaveCompanyPayment">
        <v-card-title>
          <span class="headline">{{ $t("fines.paid_company") }}</span>
          <v-icon class="ml-2 green--text" @click="saveCompanyPayment()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="paymentCompanyDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-row align="center" class="mt-2">
                <v-col auto>
                  <v-text-field v-model.number="paymentCompanyData.sum" :label="$t('bookings.get_payment')" dense
                    :messages="messageInBaseCurrency(paymentCompanyData.sum, paymentCompanyData.currency_id)"></v-text-field>
                </v-col>
                <v-col auto v-if="company && company.multicurrency_cashboxes">
                  <v-select v-model="paymentCompanyData.company_cashbox" :items="active_company_cashboxes"
                    :item-text="item => item.name" :return-object="true"
                    @change="paymentCompanyData.currency_id = paymentCompanyData.company_cashbox.currency_id, paymentCompanyData.company_cashbox_id = paymentCompanyData.company_cashbox.id"
                    :label="$t('companies.currency')" dense></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-col cols="12" class="d-flex align-center justify-space-between">
                  <v-checkbox v-if="company && company.cash_payment" v-model="paymentCompanyData.type" color="success"
                    value="Наличные" :disabled="paymentCompanyData.type == 'Терминал' ||
                      paymentCompanyData.type == 'На карту' ||
                      paymentCompanyData.type == 'Р/с' ||
                      paymentCompanyData.type == 'Баланс клиента' ||
                      isLoading
                      " class="mt-0 mr-0" dense hide-details :style="paymentCompanyData.type == 'Терминал' ||
                        paymentCompanyData.type == 'На карту' ||
                        paymentCompanyData.type == 'Р/с' ||
                        paymentCompanyData.type == 'Баланс клиента'
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="success" v-tooltip="{
                        content: $t('tooltips.cash_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-cash
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.cashless_payment" v-model="paymentCompanyData.type"
                    color="warning" value="Терминал" :disabled="paymentCompanyData.type == 'Наличные' ||
                      paymentCompanyData.type == 'На карту' ||
                      paymentCompanyData.type == 'Р/с' ||
                      paymentCompanyData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentCompanyData.type == 'Наличные' ||
                        paymentCompanyData.type == 'На карту' ||
                        paymentCompanyData.type == 'Р/с' ||
                        paymentCompanyData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-contactless-payment-circle-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.card_to_card_payment" v-model="paymentCompanyData.type"
                    color="info" value="На карту" :disabled="paymentCompanyData.type == 'Наличные' ||
                      paymentCompanyData.type == 'Терминал' ||
                      paymentCompanyData.type == 'Р/с' ||
                      paymentCompanyData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentCompanyData.type == 'Наличные' ||
                        paymentCompanyData.type == 'Терминал' ||
                        paymentCompanyData.type == 'Р/с' ||
                        paymentCompanyData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="info" v-tooltip="{
                        content: $t('money.card_to_card'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-credit-card-check-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.entity_payment" v-model="paymentCompanyData.type"
                    color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="paymentCompanyData.type == 'Наличные' ||
                      paymentCompanyData.type == 'Терминал' ||
                      paymentCompanyData.type == 'На карту' ||
                      paymentCompanyData.type == 'Баланс клиента'
                      " :style="paymentCompanyData.type == 'Наличные' ||
                        paymentCompanyData.type == 'Терминал' ||
                        paymentCompanyData.type == 'На карту' ||
                        paymentCompanyData.type == 'Баланс клиента' ||
                        isLoading
                        ? 'opacity: 0.4;'
                        : ''
                        " v-tooltip="{
                          content: $t('tooltips.entity_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                    <template v-slot:label>
                      <v-icon class="text-center" color="secondary">
                        mdi-bank
                      </v-icon>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12">
              <v-select v-model="paymentCompanyData.state" :items="fines_state" item-text="text" item-value="value"
                :label="$t('bookings.select_state')"></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(paymentCompanyDialog = false)">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="saveCompanyPayment()" :loading="isLoadingSaveCompanyPayment">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fineNotificationDialog" :retain-focus="false" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("fines.send_client") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
            (fineNotificationDialog = false),
            (fine_notify = null),
            (client_notify = null),
            (booking_notify = null),
            (sendEmail = false),
            (sendWhatsapp = false)
            ">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex md6>
                    <h4>{{ $t("bookings.booking") }}</h4>
                    <p v-if="booking_notify">
                      {{ $t("bookings.start_2") }}:
                      {{ booking_notify.start_date }}
                    </p>
                    <p v-if="booking_notify">
                      {{ $t("bookings.end_2") }}: {{ booking_notify.end_date }}
                    </p>
                    <p v-if="booking_notify">
                      {{ $t("custom.client") }}:
                      {{
                        `${booking_notify.last_name} ${booking_notify.first_name} ${booking_notify.middle_name}`
                      }}
                    </p>
                    <p v-if="booking_notify">
                      {{ $t("custom.car") }}: {{ booking_notify.car_code }}
                    </p>
                  </v-flex>
                  <div xs12 md1 class="vl"></div>
                  <v-flex md5>
                    <h4>{{ $t("fines.fine") }}</h4>
                    <p v-if="fine_notify && fine_notify.date">
                      {{ $t("fines.maded") }}:
                      {{ returnDate(fine_notify.date) }}
                    </p>
                    <p v-if="fine_notify && fine_notify.violation_date">
                      {{ $t("fines.maded") }}:
                      {{ returnDate(fine_notify.violation_date) }}
                    </p>
                    <p v-if="fine_notify">
                      {{ $t("fines.uin") }}: {{ fine_notify.uin }}
                    </p>
                    <p v-if="client_notify">
                      {{ $t("custom.email") }}: {{ client_notify.email }}
                    </p>
                    <p v-if="client_notify && client_notify.phone">
                      {{ $t("custom.phone") }}: {{ client_notify.phone }}
                    </p>
                  </v-flex>
                  <v-flex md12 class="text-center align-center">
                    <v-row justify="space-around">
                      <v-switch v-model="sendEmail" @change="checkEmail()" class="mt-0 mr-1 mr-1"
                        :label="$t('custom.email')" dense hide-details></v-switch>
                      <v-switch v-model="sendWhatsapp" v-if="$store.getters.getCompany.company"
                        @change="checkWhatsapp()" class="mt-0 mr-1 mr-1" :label="$t('custom.messengers')"
                        :disabled="!($store.getters.getCompany.company.whatsapp || $store.getters.getCompany.company.telegram_green_api_enabled || $store.getters.getCompany.company.max_enabled)" dense hide-details></v-switch>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="
            (fineNotificationDialog = false),
            (fine_notify = null),
            (client_notify = null),
            (booking_notify = null),
            (sendEmail = false),
            (sendWhatsapp = false)
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="sendFineNotification()">{{
            $t("email_templates.send")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import xlsx from "json-as-xlsx";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { saveAs } from "file-saver";
import PullToRefresh from "pulltorefreshjs";
import { translateFineState as translateFineStateText } from "@/utils/localeInfra";
export default {
  data() {
    return {
      fines: [],
      fines_state: [
        { text: this.$t("fines_state.created"), value: "Создан" },
        { text: this.$t("fines_state.notify"), value: "Оповещён" },
        { text: this.$t("fines_state.paid"), value: "Оплачен" },
        { text: this.$t("fines_state.refund"), value: "Возмещён" },
      ],
      calendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY H:mm", // Uses 'iso' if missing,
        // timeAdjust: "12:00:00",
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          dates: new Date(),
        },
      ],
      fine_date: null,
      fine_date_formatted: null,
      showAllFines: false,
      cars: [],
      workers: [],
      search: "",
      editedFine: [],
      date: null,
      selected_car: null,
      selected_client: null,
      selected_worker: null,
      selected_booking: null,
      search_client: null,
      search_booking: null,
      bookings: [],
      isLoadingBookings: false,
      showClientSearch: false,
      clients: [],
      client: null,
      isLoadingClients: false,
      fineNotificationDialog: false,
      client_notify: null,
      booking_notify: null,
      fine_notify: null,
      sendEmail: false,
      sendWhatsapp: false,
      paymentClientData: {
        id: null,
        sum: null,
        type: null,
        state: null,
        number: null,
        currency_id: null,
        company_cashbox: null,
        company_cashbox_id: null,
      },
      worker_account_id: null,
      showSelectWorkerCashbox: false,
      paymentCompanyData: {
        id: null,
        sum: null,
        type: null,
        state: null,
        number: null,
        currency_id: null,
        company_cashbox: null,
        company_cashbox_id: null,
      },
      paymentClientDialog: false,
      paymentCompanyDialog: false,
      headers: [
        { text: this.$t("fines.number"), align: "center", value: "number", sortable: true },
        { text: this.$t("custom.car"), align: "center", value: "car_code", sortable: true },
        { text: this.$t("custom.control"), sortable: false, align: "center" },
        {
          text: this.$t("fines.maded"),
          value: "violation_date",
          align: "center",
        },
        // { text: "Вынесен", value: "decision_date", align: "center" },
        {
          text: this.$t("fines.sale_until"),
          value: "discount_date",
          align: "center",
        },
        { text: this.$t("fines.article"), value: "article", align: "center", sortable: false },
        { text: this.$t("custom.client"), value: "client_id", align: "center", sortable: false },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
          sortable: false
        },
        { text: this.$t("custom.amount"), value: "amount", align: "center", sortable: false },
        {
          text: this.$t("fines.declined"),
          value: "is_revoked",
          align: "center",
          sortable: false
        },
        { text: this.$t("bookings.for_pay_2"), value: "sum", align: "center", sortable: false },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("fines.pay_status_desc"),
          value: "pay_status_desc",
          align: "center",
        },
        { text: this.$t("bookings.payment"), value: "paid", align: "center" },
        { text: this.$t("fines.state"), value: "state", align: "center" },
      ],
      headers_not_ygibdd: [
        { text: this.$t("fines.number"), align: "center", value: "number" },
        { text: this.$t("custom.car"), align: "center", value: "car_code" },
        { text: this.$t("custom.control"), sortable: false, align: "center" },
        {
          text: this.$t("fines.maded"),
          value: "violation_date",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "client_id", align: "center", sortable: false },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
          sortable: false
        },
        { text: this.$t("custom.amount"), value: "amount", align: "center", sortable: false },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("bookings.payment"), value: "paid", align: "center" },
        { text: this.$t("fines.state"), value: "state", align: "center" },
      ],
      pagination: { sortBy: "created_at", descending: true },
      editDialog: false,
      page: 1,
      per_page: 50,
      sort_by: "id",
      direction: "desc",
      tableOptions: { sortDesc: [true] }, // дефолт сортировки; :sort-desc на таблице стоять НЕ должен
      total: 0,
      timeout: null,
      isMobile: false,
      isLoading: true,
      isLoadingUpdateState: false,
      isLoadingUpdateFinePaid: false,
      isLoadingSaveClientPayment: false,
      isLoadingSaveCompanyPayment: false,
      error: "",
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (this.base_currency_id && this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        this.paymentClientData.currency_id = this.base_currency_id;
        this.paymentClientData.company_cashbox = this.active_company_cashboxes.find((cashbox) => cashbox.is_default);
        this.paymentClientData.company_cashbox_id = this.paymentClientData.company_cashbox.id;
        this.paymentCompanyData.currency_id = this.base_currency_id;
        this.paymentCompanyData.company_cashbox = this.active_company_cashboxes.find((cashbox) => cashbox.is_default);
        this.paymentCompanyData.company_cashbox_id = this.paymentCompanyData.company_cashbox.id;
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    tableOptions(pagination) {
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage;
      this.sort_by = pagination.sortBy[0] ? pagination.sortBy[0] : "id";
      this.direction = pagination.sortDesc[0] ? "desc" : "asc";
      this.getDataFromApi();
    },
    fine_date(val) {
      if (val) {
        console.log(val, "val");
        if (this.fines_monitoring_active && val) {
          // "2025-07-18 12:54:34.000000000 +0000"
          this.fine_date = moment.utc(val).format("YYYY-MM-DD HH:mm:ss");
          this.fine_date_formatted = moment.utc(val).format("DD-MM-YYYY HH:mm");
          console.log(this.fine_date, "this.fine_date");
        } else if (val && !this.fines_monitoring_active) {
          this.fine_date_formatted = moment(val, ["DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm:ss"]).format("DD-MM-YYYY HH:mm");
          this.editedFine.date = moment(val, ["DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm:ss"]).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },
    search() {
      if (this.search == "") {
        this.search = null;
      } else {
        let self = this;
        this.page = 1;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.getDataFromApi();
          }, 300); // delay
        }
        debounce();
      }
    },
    search_booking(val) {
      if (this.isLoadingBookings) {
        return;
      }
      if (typeof val === 'number') {
        this.search_booking = val.toString();
        return;
      }
      if (this.search_booking == "" || this.search_booking == " ") {
        this.search_booking = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadBookings();
          }, 300); // delay
        }
        debounce();
      }
    },
    search_client(val) {
      if (this.search_client == "" || this.search_client == " ") {
        this.search_client = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 300); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    company() {
      return this.$store.getters.getCompany.company;
    },
    worker_accounts() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.currency_accounts;
      } else {
        return [];
      }
    },
    filtredFines() {
      if (this.showAllFines) {
        return this.all_fines;
      } else {
        return this.fines;
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    exchange_rates() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.exchange_rates) {
        return this.$store.getters.getCompany.company.exchange_rates;
      } else {
        return [];
      }
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    ygibdd_active() {
      const company = this.$store.getters.getCompany?.company;
      return !!(company && (company.fines_provider === 'ygibdd' || company.ygibdd_active));
    },
    fines_monitoring_active() {
      const company = this.$store.getters.getCompany?.company;
      return !!(company && (company.fines_provider || company.ygibdd_active));
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
  },
  methods: {
    getDataFromApi() {
      this.isLoading = true;
      this.axios
        .post("api/v1/all_fines",
          {
            page: this.page,
            per_page: this.per_page,
            sort_by: this.sort_by,
            direction: this.direction,
            search: this.search,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
        .then((response) => {
          this.fines = [];
          this.all_fines = [];
          response.data.fines.data.forEach((fine) => {
            this.all_fines.push(fine.attributes);
          });

          this.total = response.data.total_fines;

          this.all_fines.forEach((fine) => {
            this.fines.push(fine);
          });
          if (this.$route.params != {} && this.$route.params.query) {
            this.search = this.$route.params.query;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.fines_load"));
        })
        .finally(() => (this.isLoading = false));
    },
    editFine(fine) {
      this.isLoading = true;
      if (fine.booking_id) {
        this.search_booking = fine.booking_id.toString();
        this.loadBookings();
      }
      if (fine.client_id) {
        this.axios
          .get(`/api/v1/clients/${fine.client_id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            let client = response.data.client;

            if (!client.entity) {
              client["fullname"] =
                client.lastname +
                " " +
                client.name +
                " " +
                client.middlename +
                " " +
                (client.phone
                  ? client.phone.slice(client.phone.length - 4)
                  : "");
            } else {
              client["fullname"] =
                client.short_entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                client.ogrn;
            }
            this.client = client;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.client_load"));
          });
      }

      this.axios
        .get(`/api/v1/fines/${fine.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          console.log(response.data.date, "response.data.date");
          console.log(response.data.violation_date, "response.data.violation_date");
          this.editedFine = response.data;
          if (response.data.date) {
            this.date = response.data.date;
            this.fine_date = moment(response.data.date).format("YYYY-MM-DD HH:mm:ss");
            this.fine_date_formatted = moment(response.data.date).format("DD-MM-YYYY HH:mm");
            console.log(this.fine_date, "this.fine_date");
          }
          if (this.fines_monitoring_active && response.data.violation_date) {
            // violation_date — wall-clock в UTC-обёртке (см. formatCreatedAtWithYear).
            // Извлекаем компоненты через getUTC*, без TZ-конвертации.
            const d = new Date(response.data.violation_date);
            const pad = (n) => String(n).padStart(2, "0");
            const y = d.getUTCFullYear();
            const mo = pad(d.getUTCMonth() + 1);
            const da = pad(d.getUTCDate());
            const h = pad(d.getUTCHours());
            const mi = pad(d.getUTCMinutes());
            const s = pad(d.getUTCSeconds());
            this.fine_date = `${y}-${mo}-${da} ${h}:${mi}:${s}`;
            this.fine_date_formatted = `${da}-${mo}-${y} ${h}:${mi}`;
          }
          if (this.editedFine && this.editedFine.booking_id) {
            this.selected_booking = { id: this.editedFine.booking_id, id_string: this.editedFine.booking_id.toString() };
          } else {
            this.selected_booking = null;
          }
          this.editDialog = true;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.fine_load"));
        })
        .finally(() => (this.isLoading = false));
    },
    saveFine() {
      if (this.isStaff) {
        this.isLoading = true;
        let fine = this.editedFine;
        let self = this;
        this.axios
          .patch(
            `/api/v1/fines/${fine.id}`,
            {
              fines: {
                sum: fine.sum,
                date: fine.date,
                state: fine.state,
                description: fine.description,
                number: fine.number,
                client_id: this.client ? this.client.id : null,
                booking_id: this.selected_booking ? this.selected_booking.id : fine.booking_id,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.fines.findIndex(
              (element) => element.id === fine.id
            );
            let fine_data = response.data;
            if (this.client && this.client.name) {
              fine_data.client_name = `${this.client.name} ${this.client.lastname}`;
            }
            this.fines.splice(foundIndex, 1, fine_data);
            this.client = null;
            this.editDialog = false;
            this.$notify(this.$t("bookings.fine_update_title"), this.$t("bookings.fine_update_text"), "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.edit_fines"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search_client,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                client.lastname +
                " " +
                client.name +
                " " +
                client.middlename +
                " " +
                (client.phone
                  ? client.phone.slice(client.phone.length - 4)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? client.entity_phone.slice(client.entity_phone.length - 4)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_load"));
        })
        .finally(() => (this.isLoadingClients = false));
    },
    loadBookings() {
      this.isLoadingBookings = true;
      this.axios
        .get(`/api/v1/search_bookings`, {
          params: {
            booking_id: this.search_booking,
          },
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.bookings = response.data ? response.data : [];
          this.bookings.forEach((booking) => {
            booking.id_string = booking.id.toString();
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.bookings_load"));
        })
        .finally(() => (this.isLoadingBookings = false));
    },
    updateState(id, state) {
      if (this.isStaff) {
        this.editedFine = this.fines.find(fine => fine.id == id);
        this.isLoadingUpdateState = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/fines/${id}`,
            {
              fines: {
                state: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.editDialog = false;
            let foundIndex = this.fines.findIndex(
              (element) => element.id === id
            );
            this.fines.splice(foundIndex, 1, response.data);
            this.$notify(this.$t("bookings.fine_update_title"), this.$t("bookings.fine_update_text"), "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.edit_fines"));
          })
          .finally(() => (this.isLoadingUpdateState = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateFinePaid(id, state) {
      if (this.isStaff) {
        this.editedFine = this.fines.find(fine => fine.id == id);
        this.isLoadingUpdateFinePaid = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/fines/${id}`,
            {
              fines: {
                paid: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.editDialog = false;
            let foundIndex = this.fines.findIndex(
              (element) => element.id === id
            );
            this.fines.splice(foundIndex, 1, response.data);
            this.$notify(this.$t("bookings.fine_update_title"), this.$t("fines.state_update"), "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.edit_fines"));
          })
          .finally(() => (this.isLoadingUpdateFinePaid = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteItem(fine) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/fines/${fine.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((response) => {
                this.fines.splice(this.fines.indexOf(fine), 1);
                this.$notify(this.$t("custom.deleted"), this.$t("fines.deleted_text"), "success", 3000);
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.delete_fine"))
              )
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    openFine(fine) {
      if (fine.print_url) {
        window.open(fine.print_url, "_blank");
      } else if (fine.ygibdd_id && fine.uin) {
        window.open(
          `https://ygibdd.ru/api/v4/business/Documents/GetSinglePdf?fineId=${fine.ygibdd_id}&uin=${fine.uin}&save=false`,
          "_blank"
        );
      }
    },
    paymentClientStart(number, id) {
      this.paymentClientData.id = id;
      this.paymentClientData.sum = 0;
      this.paymentClientData.number = number;
      this.paymentClientDialog = true;
    },
    paymentCompanyStart(number, id) {
      this.paymentCompanyData.id = id;
      this.paymentCompanyData.sum = 0;
      this.paymentCompanyData.number = number;
      this.paymentCompanyDialog = true;
    },
    saveClientPayment() {
      if (this.isStaff) {
        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
          // Проверяем если в count.type что платеж наличными
          if (this.paymentClientData && this.paymentClientData.type == "Наличные") {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            // получаем все company_cashbox_id из наличного платежа
            let cash_payments_cashbox_ids = [this.paymentClientData.company_cashbox_id];
            // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
            let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
              worker_accounts_cashboxes_ids.includes(cashbox_id)
            );
            // проверяем есть ли в кассах пользователя касса с такой валютой
            let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
            let cash_payments_currency_ids = [this.paymentClientData.currency_id];
            let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
              worker_cashboxes_currency_ids.includes(cashbox_id)
            );
            if (has_matching_worker_cashbox_currency) {
              console.log("exists worker_cashbox_currency, select first on server")
            } else {
              console.log("not exists worker_cashbox_currency")
              this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "error");
              return;
            }
          }
        }
        let self = this;
        if (
          this.paymentClientData.id &&
          this.paymentClientData.sum &&
          this.paymentClientData.type &&
          this.paymentClientData.state &&
          this.paymentClientData.number &&
          this.paymentClientData.company_cashbox_id
        ) {
          if (this.paymentClientData.type == "Баланс клиента") {
            let finded_fine = this.fines.find(fine => fine.id == this.paymentClientData.id);
            if (finded_fine && !finded_fine.client_id) {
              this.$notify(this.$t("custom.no_data"), this.$t("fines.no_data_2"), "warning", 4000);
              return;
            }
          }
          this.isLoadingSaveClientPayment = true;
          this.axios
            .post(
              `/api/v1/fines_payment`,
              {
                id: this.paymentClientData.id,
                sum: this.paymentClientData.sum,
                type: this.paymentClientData.type,
                state: this.paymentClientData.state,
                number: this.paymentClientData.number,
                company_cashbox_id: this.paymentClientData.company_cashbox_id,
                worker_account_id: this.worker_account_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              let foundIndex = this.fines.findIndex(
                (element) => element.number === self.paymentClientData.number
              );
              this.fines[foundIndex].state = this.paymentClientData.state;
              // this.fines.splice(foundIndex, 1, response.data)

              this.paymentClientDialog = false;
              this.worker_account_id = null;
              this.$notify(this.$t("fines.paid"), this.$t("fines.paid_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.fine_paid_error"));
            })
            .finally(() => (this.isLoadingSaveClientPayment = false));
        } else {
          this.isLoadingSaveClientPayment = false;
          this.$notify(this.$t("custom.no_data"), this.$t("fines.no_data_2"), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCompanyPayment() {
      if (this.isStaff) {
        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
          // Проверяем если в count.type что платеж наличными
          if (this.paymentCompanyData && this.paymentCompanyData.type == "Наличные") {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            // получаем все company_cashbox_id из наличного платежа
            let cash_payments_cashbox_ids = [this.paymentCompanyData.company_cashbox_id];
            // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
            let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
              worker_accounts_cashboxes_ids.includes(cashbox_id)
            );
            // проверяем есть ли в кассах пользователя касса с такой валютой
            let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
            let cash_payments_currency_ids = [this.paymentCompanyData.currency_id];
            let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
              worker_cashboxes_currency_ids.includes(cashbox_id)
            );
            if (has_matching_worker_cashbox_currency) {
              console.log("exists worker_cashbox_currency, select first on server")
            } else {
              console.log("not exists worker_cashbox_currency")
              this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "error");
              return;
            }
          }
        }
        let self = this;
        if (
          this.paymentCompanyData.sum &&
          this.paymentCompanyData.type &&
          this.paymentCompanyData.state &&
          this.paymentCompanyData.number &&
          this.paymentCompanyData.company_cashbox_id
        ) {
          this.isLoadingSaveCompanyPayment = true;
          this.axios
            .post(
              `/api/v1/fines_company_payment`,
              {
                id: this.paymentCompanyData.id,
                sum: this.paymentCompanyData.sum,
                type: this.paymentCompanyData.type,
                state: this.paymentCompanyData.state,
                number: this.paymentCompanyData.number,
                company_cashbox_id: this.paymentCompanyData.company_cashbox_id,
                worker_account_id: this.worker_account_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              let foundIndex = this.fines.findIndex(
                (element) => element.number === self.paymentCompanyData.number
              );
              this.fines[foundIndex].state = this.paymentCompanyData.state;
              // this.fines.splice(foundIndex, 1, response.data)

              this.paymentCompanyDialog = false;
              this.worker_account_id = null;
              this.$notify(this.$t("fines.paid"), this.$t("fines.paid_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.fine_paid_error"));
            })
            .finally(() => (this.isLoadingSaveCompanyPayment = false));
        } else {
          this.isLoading = false;
          this.$notify(this.$t("custom.no_data"), this.$t("fines.no_data_2"), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sumInBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) / parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    sumInNonBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) * parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    messageInBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(this.base_currency_id)}`;
      } else {
        return '';
      }
    },
    messageInNonBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInNonBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(currency_id)}`;
      } else {
        return '';
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    translateState(state) {
      return translateFineStateText(this.$t.bind(this), state);
    },
    stateColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Не возмещён") {
        return "error";
      }
      if (state == "Возмещён") {
        return "success";
      }
      if (state == "Оплачен") {
        return "error";
      }
    },
    selectColor(state) {
      if (state == "Оплачен") {
        if (this.$vuetify.theme.dark) {
          return "green darken-4";
        } else {
          return "green lighten-4";
        }
      }
    },
    setWorker(id) {
      if (id != null) {
        if (this.workers.find((worker) => worker.id == id)) {
          return this.workers.find((worker) => worker.id == id).name;
        }
      } else {
        return "-";
      }
    },
    toXlsx() {
      if (this.isStaff) {
        this.isLoading = true;

        let headers_with_ygibdd = [
          { label: this.$t("fines.number"), value: "number" },
          { label: this.$t("custom.car"), value: "car_code" },
          {
            label: this.$t("fines.maded"),
            value: "violation_date",
          },
          {
            label: this.$t("fines.sale_until"),
            value: "discount_date",
          },
          { label: this.$t("fines.article"), value: "article" },
          { label: this.$t("custom.client"), value: "client_id" },
          {
            label: this.$t("bookings.booking"),
            value: "booking_id",
          },
          { label: this.$t("custom.amount"), value: "amount" },
          {
            label: this.$t("fines.declined"),
            value: "is_revoked",
          },
          { label: this.$t("bookings.for_pay_2"), value: "sum" },
          {
            label: this.$t("custom.description"),
            value: "description",
          },
          {
            label: this.$t("fines.pay_status_desc"),
            value: "pay_status_desc",
          },
          { label: this.$t("bookings.payment"), value: "paid" },
          {
            label: this.$t("fines.state"),
            value: (row) => {
              return this.translateState(row.state);
            },
          },
        ]
        let headers_without_ygibdd = [
          { label: this.$t("fines.number"), value: "number" },
          { label: this.$t("custom.car"), value: "car_code" },
          {
            label: this.$t("fines.maded"),
            value: "violation_date",
          },
          { label: this.$t("custom.client"), value: "client_id" },
          {
            label: this.$t("bookings.booking"),
            value: "booking_id",
          },
          { label: this.$t("custom.amount"), value: "amount" },
          {
            label: this.$t("custom.description"),
            value: "description",
          },
          { label: this.$t("bookings.payment"), value: "paid" },
          {
            label: this.$t("fines.state"),
            value: (row) => {
              return this.translateState(row.state);
            },
          },
        ]
        let data = [
          {
            sheets: "Fines",
            columns: this.fines_monitoring_active ? headers_with_ygibdd : headers_without_ygibdd,
            content: this.all_fines,
          },
        ];
        let settings = {
          fileName: "fines", // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: "write", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {
            bookType: "xlsx",
            type: "array",
          }, // Style options from https://docs.sheetjs.com/docs/api/write-options
          RTL: false, // Display the columns from right-to-left (the default value is false)
        };
        let wbout = xlsx(data, settings);
        var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
        if (!this.isNative) {
          saveAs(blob_data, 'fines.xlsx');
        } else {
          if (Filesystem.checkPermissions()) {
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }
            getBase64FromBlob(blob_data).then(
              (base64) => {
                // save file
                async function writeFile() {
                  return await Filesystem.writeFile({
                    path: 'fines.xlsx',
                    data: base64,
                    directory: Directory.Documents,
                  });
                }
                let file_uri = null
                let writedFile = writeFile().then((getUriResult) => {
                  // share file opened file
                  let shareFile = async () => {
                    await Share.share({
                      title: 'Download document',
                      files: [getUriResult.uri],
                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  };
                  let sharedFile = shareFile();
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              }
            );
          } else {
            Filesystem.requestPermissions();
          }
        }
        this.isLoading = false;
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sendNotificationStart(fine) {
      this.isLoading = true;
      this.axios
        .get(
          `/api/v1/get_client_and_booking?client_id=${fine.client_id}&booking_id=${fine.booking_id}`,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.client_notify = response.data.client;
          this.booking_notify = response.data.booking;
          this.fine_notify = fine;
          if (this.client_notify.email) {
            this.sendEmail = true;
          }
          if (
            this.client_notify.phone &&
            (this.$store.getters.getCompany.company.whatsapp || this.$store.getters.getCompany.company.telegram_green_api_enabled || this.$store.getters.getCompany.company.max_enabled)
          ) {
            this.sendWhatsapp = true;
          }
          this.isLoading = false;
          this.fineNotificationDialog = true;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_booking_data"));
        })
        .finally(() => (this.isLoading = false));
    },
    sendFineNotification() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(
            `/api/v1/send_notification`,
            {
              client_id: this.client_notify.id,
              booking_id: this.booking_notify.id,
              fine_id: this.fine_notify.id,
              email: String(this.sendEmail),
              whatsapp: String(this.sendWhatsapp),
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.client_notify = null;
            this.booking_notify = null;
            this.fine_notify = null;
            this.sendEmail = false;
            this.sendWhatsapp = false;
            this.fineNotificationDialog = false;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.fine_notification"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkEmail() {
      if (!this.client_notify.email) {
        this.$notify(this.$t("errors.bad_email_title"), this.$t("errors.bad_email_text"), "warning");
      }
    },
    checkWhatsapp() {
      if (
        !(this.client_notify.phone && (this.$store.getters.getCompany.company.whatsapp || this.$store.getters.getCompany.company.telegram_green_api_enabled || this.$store.getters.getCompany.company.max_enabled))
      ) {
        this.$notify(this.$t("errors.fine_notification_whatsapp"), this.$t("errors.fine_notification_whatsapp_text"), "warning");
      }
    },
    showSale(date) {
      if (moment().isAfter(moment(date), "day")) {
        return false;
      } else {
        return true;
      }
    },
    checkLastDaySale(date) {
      if (moment().isSame(moment(date), "day")) {
        return true;
      } else {
        return false;
      }
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.parseZone(date).format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    formatCreatedAtWithYear(date) {
      if (!date) return "-";
      // Конвенция rentprog: violation_date хранит wall-clock места
      // нарушения в UTC-обёртке (то же, что показывают Госуслуги).
      // Берём компоненты через getUTC* — без TZ-конвертации браузера/компании.
      const d = new Date(date);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getUTCDate())}-${pad(d.getUTCMonth() + 1)}-${String(d.getUTCFullYear()).slice(2)} ${d.getUTCHours()}:${pad(d.getUTCMinutes())}`;
    },
    formatCreatedAtNoTime(date) {
      if (date && date != "0001-01-01") {
        return moment.parseZone(date).format("DD MMM");
        // return date
      } else {
        return "-";
      }
    },
    checkLateSale(date, state) {
      if (date && date != "0001-01-01" && state != "Оплачен") {
        if (moment(date).isAfter(moment())) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    returnDate(item) {
      return moment(item).format("DD MMM H:mm");
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
  },
};
</script>
<style>
.vl {
  border-left: 1px solid black;
  height: auto;
  margin-right: 1% !important;
  margin-left: 1% !important;
}
</style>
